import { useRef } from "react";
import { components } from "react-select";
import AsyncSelect from "react-select/async";
import { Controller, useFormContext } from "react-hook-form";

const errorColor = "#dc3545";
const regularBorderColor = "#ced4db";

const AsyncSelectField = ({
  name,
  fetchData,
  fieldError,
  optionLabel,
  optionValue,
  paramName = "name"
}) => {
  const { control } = useFormContext();
  const timer = useRef();
  const isFirstRender = useRef(true);
  const promiseOptions = (inputValue) => {
    if (!inputValue) return;
    const params = { [paramName]: inputValue };
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return fetchData(params);
    }
    return new Promise((resolve) => {
      clearTimeout(timer.current);
      timer.current = setTimeout(() => {
        resolve(fetchData(params));
      }, 1000);
    });
  };
  return (
    <Controller
      control={control}
      name={name}
      render={({ field }) => (
        <AsyncSelect
          {...field}
          cacheOptions
          loadOptions={promiseOptions}
          placeholder="Adresse eingeben"
          loadingMessage={() => "Wird geladen …"}
          components={{ ...components.Option }}
          onChange={(option) => field.onChange(option)}
          getOptionLabel={(option) => option[optionLabel]}
          getOptionValue={(option) => option[optionValue]}
          noOptionsMessage={({ inputValue }) =>
            inputValue ? "Keine Adresse gefunden" : "Bitte Adresse eingeben"
          }
          styles={{
            control: (base) => ({
              ...base,
              borderColor: fieldError ? errorColor : regularBorderColor,
              "&:hover": {
                borderColor: fieldError ? errorColor : "#b3b3b3"
              }
            }),
            option: (base) => ({
              ...base,
              cursor: "pointer",
              borderBottom: "1px solid #e0e0e0"
            }),
            dropdownIndicator: (base) => ({ ...base, display: "none" }),
            indicatorSeparator: (base) => ({ ...base, display: "none" })
          }}
        />
      )}
    />
  );
};

export default AsyncSelectField;
